import RepositoryError from "../errors/repository.error";
import SessionRepository from "./session.repository";
import SideMenuRepository from "./sidemenu.repository";
import FormsRepository from "./forms.repository";
import ModalsRepository from "./modals.repository";
import FieldsRepository from "./fields.repository";

const ERROR_NOT_SET = 'Repository Manager store is not set. Please set store befor accessing any repositories.';
const ERROR_NO_MODULE = 'Store used by Repository Manager does not contain requested module';

/**
 * @property store {Store}
 */
export class RepositoryManager {
    /**
     * Constructor
     */
    constructor() {
        this.instances = {};
    }

    /**
     * Set store to use
     * @param store {Store}
     */
    setStore(store) {
        this.store = store;
    }

    /**
     * Create instance of repository
     * @param name {string}
     * @param type {<T>}
     * @returns {<T>}
     */
    instantiate(name, type) {
        if (typeof this.instances[name] === 'undefined') {
            if (!this.store) {
                throw new RepositoryError(name, ERROR_NOT_SET);
            }
            if (!this.store.state[name]) {
                throw new RepositoryError(name, ERROR_NO_MODULE + ` "${name}"`);
            }
            this.instances[name] = new type(this, name);
        }
        return this.instances[name];
    }

    /**
     * Getter
     * @returns {SessionRepository}
     */
    get session() {
        return this.instantiate(
            'session',
            SessionRepository
        );
    }

    /**
     * Getter
     * @returns {SideMenuRepository}
     */
    get sideMenu() {
        return this.instantiate(
            'sideMenu',
            SideMenuRepository
        );
    }

    /**
     * Getter
     * @returns {FormsRepository}
     */
    get forms() {
        return this.instantiate(
            'forms',
            FormsRepository
        );
    }

    /**
     * Getter
     * @returns {ModalsRepository}
     */
    get modals() {
        return this.instantiate(
            'modals',
            ModalsRepository
        );
    }

    /**
     * Getter
     * @returns {FieldsRepository}
     */
    get fields() {
        return this.instantiate(
            'fields',
            FieldsRepository
        );
    }
}

const manager = new RepositoryManager();

export default manager;